import {keepPreviousData, queryOptions, useQuery} from '@tanstack/react-query'

import * as apiClient from '@/lib/api'
import {EnquiriesData} from "@/modules/enquiries/enquiries-table/types";
import {FetchParams} from "@/types/search";
import {FIVE_MINUTES} from "@/utils/constants";
import {QUERY_KEY_ENQUIRIES} from '@/utils/keys'

const { VITE_QUERY_STALE_TIME } = import.meta.env

export const buildQueryParamsString = (fetchParams: FetchParams): string => {
  const queryParams = new URLSearchParams()

  queryParams.append("limit", fetchParams.limit.toString())
  queryParams.append("offset", fetchParams.offset.toString())

  const orderByCol = fetchParams.order_by?.column ?? 'id'
  const orderByDirection = fetchParams.order_by?.direction ?? 'DESC'
  queryParams.append(`order_by[${orderByCol}]`, orderByDirection)

  if (fetchParams.professional_id) {
    queryParams.append("professional_id", fetchParams.professional_id.toString())
  }

  return queryParams.toString()
}

function fetchEnquiries(fetchParams: FetchParams): Promise<EnquiriesData> {
  return apiClient.get(`/firm/enquiries?&${buildQueryParamsString(fetchParams)}`)
}

export const enquiriesQueryOptions = (
  fetchParams: FetchParams,
) =>
  queryOptions({
    queryKey: [QUERY_KEY_ENQUIRIES, fetchParams],
    queryFn: () => fetchEnquiries(fetchParams),
    placeholderData: keepPreviousData,
    staleTime: VITE_QUERY_STALE_TIME ? Number(VITE_QUERY_STALE_TIME) : FIVE_MINUTES,
  });

export const useEnquiries = (fetchParams: FetchParams) => {
  return useQuery(enquiriesQueryOptions(fetchParams))
}
